export default __webpack_public_path__ + "static/media/sony-logo-black-and-white.26b5fd88.png";